export const NegotiationDialogStyles = {
  width: '600px',
};

export const DEFAULT_BUYING_OFFERS_PER_PAGE = 10;
export const DEFAULT_BUYING_OFFERS_NUMBER_BUTTONS = 5;
export const DEFAULT_BUYING_OFFERS_TO_SHOW_CTA_TOP = 3;

export const DEFAULT_SELLING_OFFERS_PRODUCTS_PER_PAGE = 10;
export const DEFAULT_SELLING_OFFERS_TO_SHOW_CTA_TOP = 3;

export const DEFAULT_SELLING_OFFERS_NEGOTIATIONS_PER_PAGE = 10;

export const SELLING_OFFERS_PATH = '/selling-offers/';
export const DEFAULT_LISTINGS_PRODUCTS_PER_PAGE = 10;
export const DEFAULT_LISTINGS_SHOW_CTA_TOP = 3;

export const DEFAULT_SORTBY = 'listingDate:desc';

export const LISTINGS_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
};

export const ITEMS_TO_SHIP_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
};
